<template>
  <div>
    <el-select :value="waybill_status" value-key="key" :size="size" :placeholder="$t('table.waybill_status')" @input="change($event)" :clearable="true">
      <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id" />
    </el-select>
  </div>
</template>

<script>
import {logisticsCode} from '../api/logistics_code'

export default {
  data () {
    return {
      options: [],
      waybill_status: 0
    }
  },
  created () {
    logisticsCode({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.waybill_status = val
      this.$emit('input', this.waybill_status)
    }
  },
  mounted () {
    this.waybill_status = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.waybill_status = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WayBillStatusSelect.vue